import { render, staticRenderFns } from "./CrmDeptPayway.vue?vue&type=template&id=1038134d&"
import script from "./CrmDeptPayway.vue?vue&type=script&lang=js&"
export * from "./CrmDeptPayway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports